import { Controller } from "@hotwired/stimulus"

// Tells PostHog (layouts/_analytics, production only) about a click on a link that leaves the page:
// the event and its properties are on the link (data-track-event-param, data-track-properties-param).
// Sent by beacon, so it is not lost to the navigation.
export default class extends Controller {
  capture(event: Event & { params: { event: string, properties?: Record<string, unknown> } }) {
    window.posthog?.capture(event.params.event, event.params.properties || {}, { transport: "sendBeacon" })
  }
}
